type GetWorkspaceAgentHybridTurnParkMetricsParams = {
  container: HTMLElement;
  line: HTMLElement;
};

export type WorkspaceAgentHybridTurnParkMetrics = {
  lineTop: number;
  minHeight: number;
};

/** The list has to be the window plus the example, or the example cannot scroll above the turn line. */
export const WORKSPACE_AGENT_HYBRID_TURN_PARK_SLACK_PX = 160;

/** The entrance slide is a transform, so the box position is the one to park on. */
const getElementTranslateY = (element: HTMLElement): number => {
  const { transform } = getComputedStyle(element);

  if (transform === 'none') {
    return 0;
  }

  return new DOMMatrix(transform).m42;
};

export const getWorkspaceAgentHybridTurnParkMetrics = ({
  container,
  line,
}: GetWorkspaceAgentHybridTurnParkMetricsParams): WorkspaceAgentHybridTurnParkMetrics => {
  const lineTop =
    line.getBoundingClientRect().top -
    getElementTranslateY(line) -
    container.getBoundingClientRect().top +
    container.scrollTop;

  return {
    lineTop,
    // Slack keeps the parked line off the scroll limit, so the composer clearing cannot clamp it downward.
    minHeight: container.clientHeight + lineTop + WORKSPACE_AGENT_HYBRID_TURN_PARK_SLACK_PX,
  };
};
